export default __webpack_public_path__ + "static/media/Right-Purple-Arrow.7dbcc0bf.svg";